import React from 'react'

export default () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 503.607 503.607">
    <g transform="translate(1 1)">
      <g>
        <g>
          <path d="M385.098,57.754h-41.967v-8.393c0-9.233-7.554-16.787-16.787-16.787h-25.18V24.18c0-14.269-10.911-25.18-25.18-25.18
				h-50.361c-14.269,0-25.18,11.751-25.18,25.18v8.393h-25.18c-9.233,0-16.787,7.554-16.787,16.787v8.393h-41.967
				c-23.502,0-41.967,18.466-41.967,41.967v360.918c0,23.502,18.466,41.967,41.967,41.967h268.59
				c23.502,0,41.967-18.466,41.967-41.967V99.721C427.066,76.22,408.6,57.754,385.098,57.754z M175.262,49.361h33.574
				c5.036,0,8.393-3.357,8.393-8.393V24.18c0-5.036,3.357-8.393,8.393-8.393h50.361c5.036,0,8.393,4.197,8.393,8.393v16.787
				c0,5.036,3.357,8.393,8.393,8.393h33.574v16.787v41.967H175.262V66.148V49.361z M410.279,460.639
				c0,14.269-10.911,25.18-25.18,25.18h-268.59c-14.269,0-25.18-10.911-25.18-25.18V99.721c0-14.269,10.911-25.18,25.18-25.18
				h41.967v33.574c0,9.233,7.554,16.787,16.787,16.787h151.082c9.233,0,16.787-7.554,16.787-16.787V74.541h41.967
				c14.269,0,25.18,10.911,25.18,25.18V460.639z"/>
          <path d="M317.951,228.98v-20.144h16.787c5.036,0,8.393-3.357,8.393-8.393s-3.357-8.393-8.393-8.393h-16.787h-8.393H192.049
				h-8.393h-16.787c-5.036,0-8.393,3.357-8.393,8.393s3.357,8.393,8.393,8.393h16.787v19.305c0,29.511,15.3,56.661,39.978,72.603
				c-24.678,15.942-39.978,43.092-39.978,72.603v20.144h-16.787c-5.036,0-8.393,3.357-8.393,8.393c0,5.036,3.357,8.393,8.393,8.393
				h16.787h8.393h117.508h8.393h0h16.787c5.036,0,8.393-3.357,8.393-8.393c0-5.036-3.357-8.393-8.393-8.393h-16.787v-20.144
				c0-29.256-15.04-56.188-39.343-72.184C302.911,285.168,317.951,258.236,317.951,228.98z M301.164,373.348v20.144H200.443v-19.305
				c0-28.538,16.787-52.879,43.646-64.63h13.429C284.377,320.469,301.164,345.649,301.164,373.348z M259.48,291.931h-17.354
				c-25.709-11.322-41.684-35.935-41.684-62.951v-20.144h100.721v20.144C301.164,255.996,285.189,280.61,259.48,291.931z"/>
        </g>
      </g>
    </g>
  </svg>
);